!function($, window, document) {
    const $win = $(window), $doc = $(document), $header = $(".header"), $parallaxContainers = $(".js-parallax"), players = $(".js-player:not(.js-player--alt)");
    let accordionTimeout, sidebarLeftAnimationTimeout, hidePlayBtnInterval;
    const masonryOptions = {
        columnWidth: 2,
        itemSelector: ".grid__col",
        horizontalOrder: !0,
        percentPosition: !0
    }, lockImagesBottomSpace = parseInt($(".js-link-images").css("bottom")), loopPath = document.getElementById("path"), loopImagePaths = $(".js-loop-images__inner").length ? $(".js-loop-images__inner").attr("data-image-src").split(",") : null;
    let loopImagesProgress = 0;
    let lastCursorPosition = {
        x: null,
        y: null
    };
    function isTouchDevice() {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
    function headerHeight() {
        return $header.outerHeight();
    }
    function setHeaderHeightAsCssVariable() {
        $("body").css("--header-h", `${headerHeight()}px`);
    }
    const initAOS = () => {
        AOS.init({
            offset: 50,
            delay: 200,
            duration: 800,
            once: !0
        });
    }, initParallax = $parallaxContainer => {
        const windowScrollTop = $win.scrollTop(), windowHeight = $win.height(), $parallaxContainerParent = $parallaxContainer.closest(".js-parallax-container");
        if ($parallaxContainerParent && $parallaxContainerParent.length) {
            const parallaxContainerBottom = $parallaxContainerParent && $parallaxContainerParent.length > 0 ? $parallaxContainerParent.offset().top + $parallaxContainerParent.outerHeight() : 0, velocity = ($parallaxContainer => {
                let speed = 0;
                return speed = isTablet() ? parseInt($parallaxContainer.attr("data-speed-tablet")) : isMobile() ? parseInt($parallaxContainer.attr("data-speed-mobile")) : parseInt($parallaxContainer.attr("data-speed")), 
                speed;
            })($parallaxContainer), progress = ($parallaxContainerParent.offset().top, .027 * (windowScrollTop + windowHeight - $parallaxContainerParent.offset().top) * (velocity / 10));
            $parallaxContainer[0].style.setProperty("--parallax-image-translate", `-${progress}px`);
        }
    };
    function initElementParallax($parallaxContainers) {
        $parallaxContainers.each(((idx, parallaxContainer) => {
            initParallax($(parallaxContainer));
        }));
    }
    window.initElementParallax = initElementParallax;
    const toggleFormLabelVisibility = $input => {
        const inputVal = $input.val();
        $input.closest(".js-field-parent").toggleClass("field-active", "" != inputVal);
    }, fixedHeaderMobile = () => {
        $(".header");
        const isPassedHeader = $win.scrollTop() >= headerHeight();
        $("body").toggleClass("passed-header", isPassedHeader);
    }, calculateLargestParallaxSpace = () => {
        const $parallaxContainerParent = $(".js-parallax-container"), hiddenPercentage = (() => {
            let percents = 0;
            return percents = isTablet() ? .11 : isMobile() ? .07 : .13, percents;
        })();
        $parallaxContainerParent.each((function() {
            const progress = $(this).outerHeight() * hiddenPercentage;
            this.style.setProperty("--largest-parallax-translate", `-${progress}px`);
        }));
    };
    window.calculateLargestParallaxSpace = calculateLargestParallaxSpace;
    const toggleClassForListImages = ($hoveredElement, isMouseOver) => {
        isTouchDevice() || (clearTimeout(accordionTimeout), accordionTimeout = setTimeout((() => {
            $($hoveredElement.attr("data-hover-href")).toggleClass("is-active", isMouseOver).siblings().removeClass("is-active");
        }), 100));
    }, setWidthOfElementAsCssVariable = () => {
        $(".js-borders-width").css("--inner-width", `${$(".js-borders-width").outerWidth()}px`);
    }, isMobile = () => $win.outerWidth() <= 768, isTablet = () => $win.outerWidth() <= 1100 && $win.outerWidth() > 768, initPlyrVideo = (players, options) => {
        players.each((function() {
            if (!this) return;
            const $currentMedia = $(this).closest(".media"), player = ("click" !== $currentMedia.data("autoplay") && !1 !== $currentMedia.data("autoplay") && $currentMedia.data("autoplay"), 
            new Plyr(this, {
                volume: 0,
                autoplay: !1,
                clickToPlay: !1,
                controls: [],
                muted: !0,
                loop: {
                    active: !0
                },
                vimeo: {
                    background: !0
                },
                ...options
            }));
            let observer = new IntersectionObserver((entries => {
                entries.map((entry => {}));
            }), {
                rootMargin: "0px +200px",
                threshold: 0
            });
            $currentMedia[0].plyr = player, player.on("ready", (() => {
                (video => {
                    const player = video[0].plyr;
                    video.data("mute") ? (player.muted = !0, player.volume = 0, player.decreaseVolume(100)) : (player.muted = !1, 
                    player.volume = 1, player.increaseVolume(100));
                })($currentMedia), player.pause(), observer.observe($currentMedia[0]);
            })), player.on("play", (() => {
                $currentMedia.addClass("is-played");
            })), player.on("pause", (() => {
                $currentMedia.removeClass("is-played").find(".js-play-btn").removeClass("is-played");
            }));
        }));
    }, togglePlayPauseInSlides = slides => {
        slides.each((function() {
            const $slide = $(this), $media = $slide.find(".media");
            if ($media.find(".plyr").length && $media[0].plyr && ($media[0].plyr.pause(), $slide.hasClass("slick-active"))) {
                const $currentMedia = $slide.find(".media");
                !0 === $currentMedia.data("autoplay") && $currentMedia[0].plyr.play();
            }
        }));
    }, initSlider = (slider, options) => {
        $(slider).each((function() {
            if (0 == $(this).find(".slick-initialized").length) {
                const $currentSlider = $(this), $sliderInitilizer = $currentSlider.find(".slider__slides");
                $sliderInitilizer.on("init", (function() {
                    togglePlayPauseInSlides($currentSlider.find(".slick-slide"));
                })), $sliderInitilizer.on("afterChange", (function() {
                    togglePlayPauseInSlides($currentSlider.find(".slick-slide"));
                })), $sliderInitilizer.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipe: !0,
                    draggable: !0,
                    arrows: !1,
                    autoplay: !1,
                    dots: !1,
                    responsive: [ {
                        breakpoint: 1080,
                        settings: {
                            swipe: !0,
                            draggable: !0,
                            fade: !1
                        }
                    } ],
                    ...options
                });
            }
        }));
    };
    const setFixedNavigationsHeightAsCssVariable = () => {
        const $fixedNav = $(".js-fixed-nav"), $filtersDropdown = $(".filters-dropdown");
        $fixedNav.closest(".js-fixed-nav-container").css("--nav-height", `${$filtersDropdown.outerHeight()}px`);
    }, fixedNavigations = () => {
        if (!$(".js-fixed-nav").length) return;
        const $fixedNav = $(".js-fixed-nav"), $fixedNavContainer = $fixedNav.closest(".js-fixed-nav-container"), $anchorPoint = $($fixedNav.attr("data-anchor-point")), $target = $($anchorPoint.attr("data-href")), topOfWindowPlusHeader = $win.scrollTop() + headerHeight(), hasAnchoredToContainer = topOfWindowPlusHeader >= $fixedNavContainer.offset().top;
        if ($anchorPoint.length && $target.length) {
            const hasAnchoredToElement = !(topOfWindowPlusHeader >= $target.offset().top) && (isMobile() && $(".section-fixed-nav--single-btn").length <= 0 ? $win.scrollTop() >= headerHeight() + $fixedNav.outerHeight() : topOfWindowPlusHeader >= $anchorPoint.offset().top + 2 * $anchorPoint.outerHeight());
            $fixedNavContainer.toggleClass("is-achored", hasAnchoredToElement);
        } else $fixedNavContainer.toggleClass("is-anchored", hasAnchoredToContainer);
    };
    function expandingTextAreas(textarea) {
        textarea.style.height = "0px", textarea.style.height = textarea.scrollHeight + "px";
    }
    function toggleClassOfTouchedLink(touchedLink, isTouched) {
        $(touchedLink).toggleClass("is-touched", isTouched);
    }
    function fixedSideBarOnMobile() {
        if (!isMobile()) return;
        if (!$(".js-fixed-sidebar").length) return;
        const $fixedSidebar = $(".js-fixed-sidebar");
        $win.scrollTop() + headerHeight() >= $fixedSidebar.closest(".grid__col").offset().top ? $fixedSidebar.parent().addClass("is-fixed") : $fixedSidebar.parent().removeClass("is-fixed");
    }
    function mobileFixedBarAppear() {
        if (!$(".js-fixed-bar").length) return;
        const $fixedBar = $(".js-fixed-bar"), targetSelector = $fixedBar.attr("data-target-to-scroll-past");
        if (!targetSelector) return;
        const $elementToScrollPast = $(targetSelector);
        if (console.log($elementToScrollPast), !$elementToScrollPast.length) return;
        const elementOffset = $elementToScrollPast.offset()?.top + 50 ?? 0, userhasScrolledToTargetElement = $win.scrollTop() + $win.outerHeight() >= elementOffset + $elementToScrollPast.outerHeight();
        $fixedBar.toggleClass("is-visible", userhasScrolledToTargetElement);
    }
    $(".js-scroll-next").on("click", (function(e) {
        e.preventDefault();
        const $sectionAfterBtn = $(this).closest("section").next();
        $("html, body").animate({
            scrollTop: $sectionAfterBtn.offset().top - headerHeight()
        }, 1e3);
    })), $(".tooltip__close").on("click", (function(e) {
        e.preventDefault(), $(this).parent().addClass("is-hidden");
    })), $("a").on("touchstart", (function() {
        toggleClassOfTouchedLink(this, !0);
    })), $("a").on("touchend", (function() {
        toggleClassOfTouchedLink(this, !1);
    })), $(".js-burger").on("click", (function(e) {
        e.preventDefault();
        const $burgerBtn = $(this);
        $(".nav").add($burgerBtn).toggleClass("is-active"), $("body").toggleClass("not-scrollable"), 
        $(".nav li").removeClass("is-active"), $(".nav .dropdown").slideUp();
    })), $(".js-toggle-dropdown").on("click", (function(e) {
        e.preventDefault();
        $(this).parent().toggleClass("is-active").find(".dropdown").slideToggle().closest("li").siblings().removeClass("is-active").find(".dropdown").slideUp();
    })), $(".js-more").on("click", (function(e) {
        e.preventDefault(), setTimeout((() => {
            $(".js-grid-masonry").masonry();
        }), 100), $(this).parent().addClass("hidden").siblings().removeClass("hidden");
    })), $(document).on("click", ".popup-modal-dismiss", (function(e) {
        e.preventDefault(), $.magnificPopup.close();
    })), $(document).on("click", ".js-popup-trigger", (function(e) {
        e.preventDefault();
        const $this = $(this);
        $(".js-popup").html($($this.data("id")).html()), function togglePopup(popup) {
            popup.magnificPopup({
                type: "inline",
                preloader: !1,
                modal: !0,
                fixedContentPos: !0,
                overflowY: "hidden",
                closeOnBgClick: !0,
                removalDelay: 400,
                enableEscapeKey: !0,
                callbacks: {
                    open: function() {
                        setTimeout((function() {
                            const players = $(".js-player-popup");
                            players.length > 0 && initPlyrVideo(players, {
                                controls: [ "play-large", "play", "progress", "current-time", "mute", "volume", "captions", "settings", "pip", "airplay", "fullscreen" ]
                            });
                        }), 200);
                    },
                    beforeClose: function() {
                        setTimeout((function() {
                            $(".js-popup").html(""), popup.off("click");
                        }), 400);
                    }
                }
            }).magnificPopup("open");
        }($this);
    })), $(document).on("click", ".mfp-container", (function(e) {
        $(e.target).closest(".popup").length || $.magnificPopup.close();
    })), $doc.on("click", ".js-open-popup", (function(e) {
        e.preventDefault();
        const $this = $(this), id = $this.data("id");
        $this.hasClass("js-success-action") && (window.success_element = $this), $(".popup.active").length > 0 ? ($(".popup").removeClass("active"), 
        setTimeout((() => {
            $(".popup").removeClass("visible"), $(id).addClass("visible"), setTimeout((() => {
                $(id).addClass("active");
            }), 300);
        }), 300)) : ($(id).addClass("visible"), setTimeout((() => {
            $(id).addClass("active");
        }), 0));
    })), $doc.on("click", ".popup--alt .popup__close", (function(e) {
        e.preventDefault(), $(".popup").removeClass("active");
    })), $(document).on("click", ".media", (function(e) {
        const $media = $(this), $playBtn = $media.find(".js-play-btn"), currentPlayer = $media[0].plyr;
        $playBtn.length && $playBtn.toggleClass("is-played").promise().done((function() {
            $(this).hasClass("is-played") ? currentPlayer.play() : currentPlayer.pause();
        }));
    })), $(document).on("mousemove", (function(e) {
        const $target = $(e.target);
        $(".media").each((function() {
            const $media = $(this), $playBtn = $media.find(".js-play-btn");
            $target[0] != $media[0] && $playBtn.length && $playBtn.hasClass("is-played") ? $playBtn.addClass("is-not-visible") : $playBtn.removeClass("is-not-visible"), 
            $target.closest(".media")[0] == $media[0] && (clearTimeout(hidePlayBtnInterval), 
            hidePlayBtnInterval = setTimeout((function() {
                const $currentBtn = $media.find(".js-play-btn");
                $currentBtn.hasClass("is-played") && $currentBtn.addClass("is-not-visible");
            }), 2e3), $media.find(".js-play-btn").removeClass("is-not-visible"));
        }));
    })), $(".js-hero-image-animation").on("mousemove", (function(e) {
        !function imagesFollowingCursorAnimation(cursrorLeft, cursrorTop) {
            if (!$(".js-animated-images").length) return;
            const $followImagesContainer = $(".js-animated-images"), randomNumberOfImagePath = Math.floor(Math.random() * loopImagePaths.length), currentImage = `<img class="loop-image" src="${loopImagePaths[randomNumberOfImagePath]}" alt="">`, animatedImages = $(".js-animated-images img");
            let currentPosition = {
                x: cursrorLeft,
                y: cursrorTop
            };
            if (null === lastCursorPosition.x || null === lastCursorPosition.y || Math.abs(currentPosition.x - lastCursorPosition.x) >= 80 || Math.abs(currentPosition.y - lastCursorPosition.y) >= 80) {
                $followImagesContainer.append(currentImage);
                const $lastLoopImage = $(".js-animated-images img").last();
                $lastLoopImage.addClass("is-active"), $lastLoopImage.css({
                    "--top": cursrorTop - 100 + "px",
                    "--left": cursrorLeft - 100 + "px"
                }), lastCursorPosition = currentPosition;
            }
            setTimeout((() => {
                for (let i = 0; i < animatedImages.length; i++) {
                    const animatedImage = animatedImages[i];
                    setTimeout((() => {
                        $(animatedImage).remove();
                    }), 10 * i);
                }
            }), 500);
        }(e.clientX, e.clientY);
    })), $doc.on("propertychange input blur", "input", (function() {
        toggleFormLabelVisibility($(this));
        const inputVal = $(this).val();
        $(this).closest(".js-field-parent").toggleClass("field-active", "" != inputVal);
    })), $doc.on("focus", "input", (function() {
        $(this).closest(".js-field-parent").addClass("field-active");
    })), $doc.on("change", "select", (function() {
        toggleFormLabelVisibility($(this));
    })), $(".js-input").on("click", (function(e) {
        e.preventDefault();
        const $changeValueBtn = $(this), isIncrementing = $changeValueBtn.attr("data-increment"), inputToIncrement = $changeValueBtn.closest("ul").find(".js-input-result");
        let inputValue = parseInt(inputToIncrement.val());
        const setValueToInput = $(inputToIncrement.attr("data-set-id-input")), inputRequiredQty = parseInt(inputToIncrement.attr("data-req-qty")) || 0;
        if ("false" == isIncrementing) {
            const newValue = inputValue - 1;
            inputValue = newValue < inputRequiredQty ? 0 : newValue;
        } else inputValue = inputValue < inputRequiredQty ? inputRequiredQty : inputValue + 1;
        inputValue < 0 || (inputToIncrement.val(inputValue), setValueToInput.val(inputValue), 
        inputToIncrement.trigger("change"));
    })), $doc.on("click", (function(e) {
        $(".tooltip").removeClass("is-active");
    })), $(".tooltip").on("click", (function(e) {
        const $tooltip = $(this);
        if (isMobile()) {
            const topSpaceToTooltip = $tooltip.offset().top - $tooltip.find(".tooltip__inner").outerHeight() - $win.scrollTop(), leftSpaceToTooltip = $tooltip.offset().left - $tooltip.outerWidth() / 2 - 3;
            $tooltip.css("--top", `${topSpaceToTooltip}px`), $tooltip.css("--left", `${leftSpaceToTooltip}px`), 
            setTimeout((() => {
                $tooltip.hasClass("is-active") ? $tooltip.removeClass("is-active") : $tooltip.addClass("is-active");
            }));
        }
    })), $doc.on("click", ".js-close-tooltip", (function(e) {
        setTimeout((() => {
            $(".tooltip").removeClass("is-active");
        }));
    })), $doc.on("click", ".js-success-action", (function(e) {
        window.success_element = $(this);
    }));
    function scrollSpyElements() {
        const $scrollSpyElements = $(".js-scrollspy-element");
        $scrollSpyElements.length && $scrollSpyElements.each((function() {
            const $scrollSpyElement = $(this);
            let fixedContainerHeight = isMobile() ? $(".js-fixed-nav").outerHeight() : 0;
            const hederFixedDifference = isMobile() && !$("body").hasClass("passed-header") && $(".js-fixed-sidebar").length <= 0 ? 0 : 26;
            fixedContainerHeight || (fixedContainerHeight = $(".js-fixed-sidebar").parent().outerHeight());
            const scrollSpyElementIsEntered = isMobile() ? $win.scrollTop() + headerHeight() + fixedContainerHeight >= $scrollSpyElement.offset().top - hederFixedDifference : $win.scrollTop() + headerHeight() >= $scrollSpyElement.offset().top - hederFixedDifference, scrollSpyElementIsNotExceeded = $win.scrollTop() + headerHeight() <= $scrollSpyElement.offset().top + $scrollSpyElement.outerHeight();
            if (scrollSpyElementIsEntered && scrollSpyElementIsNotExceeded) {
                const scrollSpyElementId = $scrollSpyElement.attr("id"), $linkBoundToScrollSpyElement = $(`[data-href='#${scrollSpyElementId}']`);
                $linkBoundToScrollSpyElement.parent().addClass("is-current").siblings().removeClass("is-current"), 
                clearTimeout(sidebarLeftAnimationTimeout), sidebarLeftAnimationTimeout = setTimeout((() => {
                    const leftDistanceToVisibleTile = $win.outerWidth() - ($linkBoundToScrollSpyElement.offset().left + $linkBoundToScrollSpyElement.outerWidth());
                    $(".js-fixed-sidebar").length && $linkBoundToScrollSpyElement.closest("ul").animate({
                        scrollLeft: -1 * leftDistanceToVisibleTile + $linkBoundToScrollSpyElement.closest(".js-fixed-sidebar")[0].scrollLeft + 10
                    }, 400);
                }), 100);
            }
        }));
    }
    function showLinkImagesWhenInCenterOfViewport() {
        const $relativeLinkToImages = $(".js-hover-link"), scrollTop = $win.scrollTop(), halfWindowHeight = $win.outerHeight() / 2;
        $relativeLinkToImages.each((function() {
            const $relativeLink = $(this), linkIsInCenterOfViewPort = scrollTop + halfWindowHeight + headerHeight() >= $relativeLink.offset().top + $relativeLink.outerHeight() / 2, linkIsPassed = scrollTop + halfWindowHeight + headerHeight() < $relativeLink.offset().top + $relativeLink.outerHeight();
            if (linkIsInCenterOfViewPort && linkIsPassed && isTouchDevice()) {
                const $target = $($relativeLink.attr("data-hover-href"));
                $relativeLink.parent().addClass("is-active").siblings().removeClass("is-active"), 
                $target.addClass("is-active").siblings().removeClass("is-active");
            }
        }));
    }
    function addClassToScrollSpyLinks() {
        $(".js-fixed-sidebar").length && $(".js-fixed-sidebar").each((function() {
            const $sidebar = $(this);
            $sidebar[0].getBoundingClientRect().width + 1 > $sidebar.closest(".grid__col")[0].getBoundingClientRect().width ? $sidebar.parent().addClass("has-overflow") : $sidebar.parent().removeClass("has-overflow");
        }));
    }
    function lockLinkImages() {
        if (!$(".js-link-images").length) return;
        const $lockImages = $(".js-link-images"), $lockImagesContainer = $(".js-lock-body"), imageIsAtBottom = $win.scrollTop() + $win.outerHeight() - lockImagesBottomSpace >= $lockImagesContainer.offset().top + $lockImagesContainer.outerHeight(), imageIsAtTop = $win.scrollTop() + $win.outerHeight() - $lockImages.outerHeight() <= $lockImagesContainer.offset().top + lockImagesBottomSpace, spaceBetweenBodyAndTopOfSection = $lockImagesContainer.offset().top - $lockImages.closest("section").offset().top, bottomSpaceBetweenBodyAndTopOfSection = $lockImages.closest("section").offset().top + $lockImages.closest("section").outerHeight() - ($lockImagesContainer.offset().top + $lockImagesContainer.outerHeight());
        $lockImages.css({
            "--top": `${spaceBetweenBodyAndTopOfSection}px`,
            "--bottom": `${bottomSpaceBetweenBodyAndTopOfSection}px`
        }), imageIsAtBottom ? $lockImages.addClass("is-locked") : imageIsAtTop ? $lockImages.addClass("is-locked-at-top") : ($lockImages.removeClass("is-locked-at-top"), 
        $lockImages.removeClass("is-locked"));
    }
    $(".js-fixed-sidebar").each((function() {
        $(this)[0].addEventListener("scroll", (e => {
            $(e.srcElement).closest(".grid__col").addClass("hide-tooltip");
        }));
    })), $('.js-toggle-tickets-accordion input[type="radio"]').on("click", (function(e) {
        const dateValue = $(this).val();
        if (dateValue) {
            const $datesAccordions = $(".accordion__body[data-subvenue-id]");
            let hasClicked = !1;
            $datesAccordions.each((function() {
                const $this = $(this), $radios = $this.find('input[type="radio"][data-date="' + dateValue + '"]');
                $this.find(".list-radios-dates > li").hide(), $this.hide(), $radios.length >= 10 ? ($this.find(".list-radios-dates").removeClass("list-radios-dates--large").addClass("list-radios-dates--medium"), 
                $radios.removeClass("radio-date--large").addClass("radio-date--medium")) : ($this.find(".list-radios-dates").removeClass("list-radios-dates--medium").addClass("list-radios-dates--large"), 
                $radios.removeClass("radio-date--medium").addClass("radio-date--large")), $radios.length && ($this.data("expanded") ? $this.show() : ($this.fadeIn(), 
                $this.data("expanded", !0)), $radios.each((function() {
                    $(this).closest("li").show();
                })), (1 === $radios.length || !hasClicked && $datesAccordions.find('input[type="radio"][name="check-session-time"]:checked').length > 0) && (setTimeout((function() {
                    $radios.first().trigger("click");
                }), 175), hasClicked = !0));
            })), window.innerWidth < 768 && $("html, body").animate({
                scrollTop: $datesAccordions.offset().top - headerHeight() - 150
            }, 1e3);
        }
    }));
    const $ticketAccordionBody = $doc.find('[data-section="ticket-types"] .accordion__body'), $performanceIdInput = $('#add-ticket-to-cart input[name="performance_id"]'), $listPriceItems = $ticketAccordionBody.find(".list-price > li"), $numberInputs = new Map;
    $listPriceItems.each((function() {
        const $li = $(this);
        $numberInputs.set($li[0], $li.find('input[type="number"]'));
    })), $(".list-radios-dates").on("change", 'input[type="radio"][name="check-session-time"]', (function() {
        const performanceId = $(this).data("perf-id");
        $ticketAccordionBody.fadeIn(), $performanceIdInput.val(performanceId), $listPriceItems.each((function() {
            const $li = $(this), $numberInput = $numberInputs.get(this), _performanceId = $li.data("performance-id"), shouldShow = _performanceId && _performanceId.includes(performanceId);
            $li.toggle(shouldShow), $numberInput.prop("disabled") === !shouldShow && "0" === $numberInput.val() || $numberInput.val(0).prop("disabled", !shouldShow).trigger("change");
        }));
        let foundFirstVisible = !1;
        $(".list-price").each((function() {
            const $priceList = $(this), $header = $priceList.prev(".h6");
            $priceList.toggleClass("hidden", !1);
            const hasVisibleItems = $priceList.find("li:visible").length > 0;
            $priceList.toggleClass("hidden", !hasVisibleItems), $header.toggle(hasVisibleItems), 
            hasVisibleItems && !foundFirstVisible && ($(".h6").removeClass("is-first"), $header.addClass("is-first"), 
            foundFirstVisible = !0);
        }));
    })), $('.list-increment input[type="number"]').on("change", (function(e) {
        const $allListIncrementInputs = $doc.find('.list-increment input[type="number"]:not(:disabled)');
        let cumulativeValue = 0;
        $allListIncrementInputs.each((function() {
            cumulativeValue += parseInt($(this).val());
        })), $(".js-submit-tickets").toggleClass("btn--disabled", 0 == cumulativeValue);
    })), $(".js-toggle-large-links").on("click", (function(e) {
        e.preventDefault();
        const $btn = $(this);
        $btn.closest("section").find(".js-large-links .is-hidden").slideDown(), setTimeout((() => {
            $btn.addClass("hidden");
        }), 400);
    })), $(".js-accordion-tickets .accordion__head").on("click", (function(e) {
        e.preventDefault(), $(this).next().stop(!0, !0).slideToggle().closest(".accordion__section").toggleClass("is-expanded"), 
        $(".js-accordion-tickets").find(".is-expanded").length <= 0 && ($(".js-accordion-tickets .accordion__section").removeClass("is-expanded is-clickable"), 
        $('.js-toggle-tickets-accordion input[type="radio"]').map(((index, input) => {
            $(input).prop("checked", !1);
        })));
    })), $(".js-toggle-filters").on("click", (function(e) {
        if (!isTouchDevice()) return;
        e.preventDefault();
        const $filterBtn = $(this), $filtersDropdownHeight = $filterBtn.next().outerHeight();
        $filterBtn.parent().toggleClass("is-active").siblings().removeClass("is-active");
        const addedPaddingToWrapper = $filterBtn.parent().hasClass("is-active") ? $filtersDropdownHeight : 0;
        $("body").css("--dropdown-height", `${addedPaddingToWrapper}px`);
    }));
    function imagesToFollowSvgPathAnimation() {
        if (!$(".js-loop-images").length) return;
        loopImagesProgress += 15, loopImagesProgress > function getLoopPathLength() {
            if (loopImagePaths) return loopPath.getTotalLength();
        }() && (loopImagesProgress = 0);
        const point = loopPath.getPointAtLength(loopImagesProgress), loopImageContainer = $(".js-loop-images"), loopImagesContainerWidth = loopImageContainer.outerWidth(), loopImagesContainerHeight = loopImageContainer.outerHeight(), randomNumberOfImagePath = Math.floor(Math.random() * loopImagePaths.length), currentImage = `<img class="loop-image" src="${loopImagePaths[randomNumberOfImagePath]}" alt="">`;
        $(".js-loop-images__inner").append(currentImage), setTimeout((() => {
            const topPositionOfImage = point.y * loopImagesContainerHeight / 182 - $(".js-loop-images__inner img").last().outerHeight() / 2, leftPositionOfImage = point.x * loopImagesContainerWidth / 192 - $(".js-loop-images__inner img").last().outerWidth() / 2, $lastLoopImage = $(".js-loop-images__inner img").last();
            $lastLoopImage.addClass("is-active"), $lastLoopImage.css({
                "--top": `${topPositionOfImage}px`,
                "--left": `${leftPositionOfImage}px`
            }), $(".js-loop-images__inner img").length >= loopImagePaths.length && $(".js-loop-images__inner img").first().remove();
        }), 10);
    }
    function setContainerSpacing() {
        const $container = $(".container").first();
        if ($container.length) {
            const containerSpacing = parseInt($container.css("margin-left"));
            $(":root").css("--container-spacing", `${containerSpacing}px`);
        }
    }
    $doc.on("click", "a[data-href]:not(.js-fixed-sidebar a)", (function(e) {
        const $scrollToLink = $(this), $elementToScrollTo = $($scrollToLink.attr("data-href"));
        if ($elementToScrollTo.length) {
            e.preventDefault();
            const parentHeight = $scrollToLink.closest("ul").outerHeight() || 0, parentPaddingBottom = parseInt($scrollToLink.closest("ul").css("padding-bottom")) || 0, scrollDistance = isMobile() ? $elementToScrollTo.offset().top - (headerHeight() + (parentHeight - parentPaddingBottom)) - 25 : $elementToScrollTo.offset().top - headerHeight() - 25;
            let hederFixedDifference = isMobile() && $("body").hasClass("passed-header") ? 0 : 26;
            $scrollToLink.closest(".js-fixed-sidebar").length && (hederFixedDifference = 0), 
            $("html, body").animate({
                scrollTop: scrollDistance + hederFixedDifference
            }, 1e3);
            var page = $("html, body");
            $("html, body").on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", (function() {
                page.stop();
            }));
        } else console.log("no element to scroll to");
    })), $("#search-pagination").on("change", (function() {
        window.location.href = $(this).val();
    })), $(".js-select-filters select").on("change", (function(e) {})), $(".js-pick-show").on("change", (function(e) {
        const selectedValue = $(this).val();
        selectedValue.length > 0 && (window.location.href = selectedValue);
    })), $(".js-hover-link").on("mouseover", (function(e) {
        toggleClassForListImages($(this), !0);
    })), $(".js-hover-link").on("mouseleave", (function(e) {
        e.preventDefault(), toggleClassForListImages($(this), !1);
    })), $doc.on("click", ".js-clear-selection", (function(e) {
        e.preventDefault();
        const filterId = $(this).data("filter"), $filterSelect = $(`#${filterId}`);
        $filterSelect.prop("selectedIndex", 0), $(this).closest("li").remove(), $filterSelect.trigger("change");
    }));
    var options;
    new ResizeObserver((entries => {
        setHeaderHeightAsCssVariable();
    })).observe($header[0]), setHeaderHeightAsCssVariable(), initSlider(".js-slider", {
        dots: !0,
        arrows: !0,
        responsive: [ {
            breakpoint: 767,
            settings: {
                arrows: !1
            }
        } ]
    }), initSlider(".js-slider-section", {
        dots: !0,
        arrows: !0,
        centerMode: !0,
        responsive: [ {
            breakpoint: 1100,
            settings: {
                arrows: !1
            }
        } ]
    }), options = {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: !0,
        infinite: !1,
        responsive: [ {
            breakpoint: 1100,
            settings: {
                slidesToScroll: 2,
                slidesToShow: 2,
                swipe: !0,
                draggable: !0,
                fade: !1
            }
        }, {
            breakpoint: 1100,
            settings: {
                slidesToScroll: 1,
                slidesToShow: 1,
                arrows: !1
            }
        } ]
    }, $(".js-slider-articles").each((function() {
        if (!$(this).hasClass("slick-slider")) {
            const $currentSlider = $(this);
            $currentSlider.on("init", (function() {
                togglePlayPauseInSlides($currentSlider);
            })), $currentSlider.on("afterChange", (function() {
                togglePlayPauseInSlides($currentSlider);
            })), $currentSlider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                swipe: !0,
                draggable: !0,
                arrows: !1,
                autoplay: !1,
                dots: !1,
                responsive: [ {
                    breakpoint: 1080,
                    settings: {
                        swipe: !0,
                        draggable: !0,
                        fade: !1
                    }
                } ],
                ...options
            });
        }
    })), initPlyrVideo(players), $tileSlider = $(".js-tile-slider"), $tileSlider.length && $tileSlider.slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: !1,
        arrows: !0,
        threshold: 20,
        responsive: [ {
            breakpoint: 1080,
            settings: {
                slidesToShow: 3.2,
                slidesToScroll: 1,
                infinite: !1,
                arrows: !0
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 2.2,
                slidesToScroll: 1,
                infinite: !1,
                arrows: !1
            }
        } ]
    }), $("textarea").on("input", (function() {
        expandingTextAreas(this);
    })), setFixedNavigationsHeightAsCssVariable(), function initTicker() {
        $(".js-ticker").each((function(index, el) {
            $(el).marquee({
                duration: 2e6,
                direction: "left",
                speed: 40,
                duplicated: !0,
                startVisible: !0
            });
        }));
    }(), fixedHeaderMobile(), imagesToFollowSvgPathAnimation(), setInterval((() => {
        (isMobile() || isTablet()) && requestAnimationFrame(imagesToFollowSvgPathAnimation);
    }), 150), $win.on("load", (function() {
        $(".js-grid-masonry").masonry(masonryOptions), calculateLargestParallaxSpace(), 
        fixedNavigations(), function stickySidebar() {
            const $columns = $(".js-fixed-sidebar");
            $win.width() > 812 && $columns.length && $columns.each((function(index, el) {
                $(this).stick_in_parent({
                    offset_top: headerHeight() + 60
                });
            }));
        }(), scrollSpyElements(), showLinkImagesWhenInCenterOfViewport(), lockLinkImages(), 
        setWidthOfElementAsCssVariable(), fixedSideBarOnMobile(), function initEventFiltering() {
            function applyFilters(e) {
                const selectedView = $(".list-filters").attr("data-filter-view"), selectedGenre = $("#genre").val() || "", selectedDate = $("#date").val() || "", selectedTime = $("#time").val() || "", selectedCuisine = $("#cuisine").val() || "", selectedDietary = $("#dietary").val() || "", selectedFormat = $("#format").val() || "";
                $("#genre").parent().attr("data-selected-value", $("#genre").find("option:selected").text()), 
                $("#date").parent().attr("data-selected-value", $("#date").find("option:selected").text()), 
                $("#time").parent().attr("data-selected-value", $("#time").find("option:selected").text()), 
                $("#cuisine").parent().attr("data-selected-value", $("#cuisine").find("option:selected").text()), 
                $("#dietary").parent().attr("data-selected-value", $("#dietary").find("option:selected").text()), 
                $("#format").parent().attr("data-selected-value", $("#format").find("option:selected").text()), 
                $(".section-cards").each((function() {
                    let sectionVisibleIndex = 0;
                    $(this).find('.filter-tile[data-first-chunk="true"]').each((function() {
                        const $tile = $(this), filterText = $tile.data("filter");
                        if (!$tile.hasClass("card-ad") && filterText && filterText.length > 0) {
                            const genreMatch = !selectedGenre || filterText.includes(selectedGenre), dateMatch = !selectedDate || filterText.includes(selectedDate), timeMatch = !selectedTime || filterText.includes(selectedTime), cuisineMatch = !selectedCuisine || filterText.includes(selectedCuisine), dietaryMatch = !selectedDietary || filterText.includes(selectedDietary), formatMatch = !selectedFormat || filterText.includes(selectedFormat);
                            let viewMatch = !0;
                            "all" !== selectedView && (viewMatch = !selectedView || filterText.includes(selectedView));
                            const isVisible = genreMatch && dateMatch && timeMatch && cuisineMatch && dietaryMatch && formatMatch && viewMatch;
                            if ($tile.toggle(isVisible), isVisible) {
                                const tileSpeeds = function calculateTileSpeed(index) {
                                    const speeds = {
                                        desktop: [ 60, 30, 90, 45 ],
                                        tablet: [ 35, 30, 40 ],
                                        mobile: [ 30, 20 ]
                                    };
                                    return {
                                        desktop: speeds.desktop[index % speeds.desktop.length],
                                        tablet: speeds.tablet[index % speeds.tablet.length],
                                        mobile: speeds.mobile[index % speeds.mobile.length]
                                    };
                                }(sectionVisibleIndex), $card = $tile.find(".card.js-parallax");
                                $card.attr("data-speed", tileSpeeds.desktop), $card.attr("data-speed-tablet", tileSpeeds.tablet), 
                                $card.attr("data-speed-mobile", tileSpeeds.mobile), sectionVisibleIndex++;
                            }
                        } else selectedGenre.length > 0 || selectedDate.length > 0 || selectedTime.length > 0 || selectedCuisine.length > 0 || selectedDietary.length > 0 || selectedFormat.length > 0 ? $tile.toggle(!1) : $tile.toggle(!0);
                    }));
                })), selectedGenre.length > 0 || selectedDate.length > 0 || selectedTime.length > 0 || selectedCuisine.length > 0 || selectedDietary.length > 0 || selectedFormat.length > 0 || "all" !== selectedView ? ($(".section-cards:not(.section-cards--first)").hide(), 
                $('.filter-tile[data-first-chunk="false"]').hide(), $(".card--paid").hide(), $(".module--call_to_action").hide(), 
                $(".cards-ads").hide()) : ($(".section-cards").show(), $('.filter-tile[data-filtered-only="true"]:not(.card-ad)').hide(), 
                $('.filter-tile[data-filtered-only="false"]').show(), $(".module--call_to_action").show(), 
                $(".cards-ads").show()), isMobile() && ($(".js-selections").html(""), $("#genre, #date, #time").each((function() {
                    const $filterSelect = $(this), $filterSelectValue = $filterSelect.find("option:selected").text();
                    if (0 === $filterSelect.prop("selectedIndex")) return;
                    const newSelections = `\n                        <li>\n                            <a href="#" class="js-clear-selection" data-filter="${$filterSelect.attr("id")}">\n                                <img src="/wp-content/themes/goud/assets/src/images/selection-close.svg" alt="">\n                                ${$filterSelectValue}\n                            </a>\n                        </li>\n                    `;
                    $(".js-selections").append(newSelections);
                }))), updateResultCount(), $(".js-grid-masonry").masonry(masonryOptions), initElementParallax($parallaxContainers);
            }
            function updateResultCount() {
                const visibleTiles = $(".filter-tile:visible").length, totalTiles = $(".filter-tile").length;
                $("#result-count").text(`Showing ${visibleTiles} of ${totalTiles} events`), $("#no-results").toggle(0 === visibleTiles);
            }
            $("#pick-show, #genre, #date, #time, #cuisine, #dietary, #format").on("change", applyFilters), 
            $("[data-view]").on("click", (function() {
                const _view = $(this).data("view");
                if ($("#genre, #date, #time, #cuisine, #dietary, #format").val(""), void 0 !== _view && _view.length > 0) switch ($("[data-filter-view]").attr("data-filter-view", _view), 
                _view) {
                  case "all":
                  case "shows":
                    $("[data-title]").text("What's on");
                    break;

                  case "food-and-drink":
                    $("[data-title]").text("Food & Drink");
                    break;

                  case "rides-and-stalls":
                    $("[data-title]").text("Rides & Stalls");
                }
                applyFilters();
            })), $("#reset-filters").on("click", (function() {
                $("#genre, #date, #time, #cuisine, #dietary, #format").val(""), applyFilters();
            })), updateResultCount();
        }(), setContainerSpacing(), $doc.on("click", ".js-toggle-search, .js-close-search", (function(e) {
            e.preventDefault(), $(".header-search-form").fadeToggle(300);
        })), $doc.on("click", (function(e) {
            const $searchForm = $(".header-search-form");
            !$searchForm.is(":visible") || $(e.target).closest(".header-search-form").length || $(e.target).closest(".js-toggle-search").length || $searchForm.fadeOut(300);
        })), function checkUrlHashAndTriggerClick() {
            const hash = window.location.hash;
            if (hash) {
                const targetId = hash.replace("#", ""), $element = $(`[data-view="${targetId}"]`);
                $element.length && $element.trigger("click");
            }
        }(), function setAccordionHeight() {
            setTimeout((function() {
                const $mapAccordion = $(".section-map .section__accordion");
                if ($mapAccordion.length) {
                    const accordionHeight = $mapAccordion.outerHeight();
                    document.documentElement.style.setProperty("--accordion-height", `${accordionHeight}px`);
                }
            }), 1e3);
        }(), "/whats-on/" === window.location.pathname && initAOS(), $("textarea").each((function() {
            expandingTextAreas(this);
        })), initElementParallax($parallaxContainers), mobileFixedBarAppear(), addClassToScrollSpyLinks(), 
        $(".aos-force").addClass("aos-animate");
    })).on("scroll", (function() {
        initElementParallax($parallaxContainers), fixedNavigations(), scrollSpyElements(), 
        showLinkImagesWhenInCenterOfViewport(), lockLinkImages(), mobileFixedBarAppear(), 
        fixedHeaderMobile(), fixedSideBarOnMobile(), $(".tooltip").removeClass("is-active");
    })).on("resize", (function() {
        setHeaderHeightAsCssVariable(), setFixedNavigationsHeightAsCssVariable(), setWidthOfElementAsCssVariable(), 
        addClassToScrollSpyLinks(), setContainerSpacing(), $win.outerWidth() >= 1100 && $doc.find(".js-burger.is-active").length > 0 && $(".js-burger.is-active").trigger("click");
    })), "/whats-on/" !== window.location.pathname && initAOS(), $(".js-accordion-map .accordion__body").slideUp(), 
    $(".js-accordion-map .accordion__head > a").on("click", (function(e) {
        e.preventDefault();
        const $accordion = $(this), $accordionParentText = $accordion.parent().attr("data-text"), $accordionSection = $accordion.closest(".accordion__section"), $accordionBody = $accordion.closest(".accordion__head").next(".accordion__body"), wasExpanded = $accordionSection.hasClass("is-expanded");
        $accordionBody.slideToggle().closest(".accordion__section").toggleClass("is-expanded").siblings().removeClass("is-expanded").find(".accordion__body").slideUp(), 
        $(window).width() < 1100 && ($(".section-map .section__accordion").removeClass("is-active"), 
        $(".wrapper").removeClass("is-active-filter"), wasExpanded ? ($(".section-map .section__outer").removeClass("is-visible"), 
        $(".map-alt").removeClass("is-active"), $(".filter-map h6 span").text("")) : ($(".section-map .section__outer").addClass("is-visible"), 
        $(".map-alt").addClass("is-active"), $(".filter-map h6 span").text(": " + $accordionParentText)));
    })), $(".js-map-overlay-open").each((function() {
        const $overlay = $(this);
        $overlay.on("click", (function(e) {
            e.preventDefault();
            const targetSelector = $overlay.attr("data-location-category");
            $('[data-tooltip="' + targetSelector + '"]').toggleClass("is-active").siblings().removeClass("is-active");
        }));
    })), $(".js-link-tooltip").each((function() {
        const $link = $(this), $tooltip = $($link.attr("href")), dataX = $link.data("x"), dataY = $link.data("y");
        $link.on("click", (function(e) {
            e.preventDefault(), $link.toggleClass("is-active").parent().siblings().find(".js-link-tooltip").removeClass("is-active"), 
            $tooltip.toggleClass("is-active").siblings().removeClass("is-active");
        })), $tooltip.css({
            top: dataX + "%",
            left: dataY + "%"
        });
    })), $(".tooltip-map .tooltip__icon").on("click", (function(e) {
        e.preventDefault();
        const $icon = $(this), targetId = $icon.parent().attr("id");
        $(`.js-link-tooltip[href='#${targetId}']`).toggleClass("is-active").parent().siblings().find("a").removeClass("is-active"), 
        $icon.parent().toggleClass("is-active").siblings().removeClass("is-active");
    })), $(".js-expand-map").on("click", (function(e) {
        e.preventDefault();
        const $sectionContent = $(this).parent(".section__accordion"), $sectionMap = $(".section__map");
        $sectionContent.toggleClass("is-expanded"), $sectionMap.toggleClass("is-expanded");
    })), $(".js-close-filter").on("click", (function(e) {
        e.preventDefault(), $(".section-map .section__accordion").removeClass("is-active"), 
        $(".wrapper").removeClass("is-active-filter");
    })), $(".js-open-filter").on("click", (function(e) {
        e.preventDefault(), $(".section-map .section__accordion").addClass("is-active"), 
        $(".wrapper").addClass("is-active-filter");
    }));
    let lastScrollTop = 0, isAnimating = !1;
    $(window).on("scroll", (function() {
        const scrollTop = $(this).scrollTop();
        if ($(window).width() < 1100) {
            const $sectionOuter = $(".section-map .section__outer");
            scrollTop > lastScrollTop && $sectionOuter.hasClass("is-visible") || !isAnimating && $sectionOuter.hasClass("is-active") && (isAnimating = !0, 
            $sectionOuter.animate({
                scrollTop: 0
            }, 300, (function() {
                isAnimating = !1;
            }))), lastScrollTop = scrollTop;
        }
    })), $(".js-tooltip-close").on("click", (function(e) {
        e.preventDefault();
        $(this).closest(".tooltip-map").removeClass("is-active");
    }));
}(jQuery, window, document);